import { render, staticRenderFns } from "./organizaManagement.vue?vue&type=template&id=1385bb2c&scoped=true&"
import script from "./organizaManagement.vue?vue&type=script&lang=js&"
export * from "./organizaManagement.vue?vue&type=script&lang=js&"
import style0 from "./organizaManagement.vue?vue&type=style&index=0&id=1385bb2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1385bb2c",
  null
  
)

export default component.exports